import React, {Component} from 'react';
import Navbar from "../Common/Navbar";
import Actionbar from "../Common/Actionbar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarAlt, faDownload,  faTruck} from '@fortawesome/free-solid-svg-icons'
import API from "../../services/API";

import moment from "moment-jalaali";

import Toast from "../Common/Toast";
import Loading from "../Common/Loading";

let pages = [];
for(let p = 1 ; p < 50 ; p++){
    pages[p] = p;
}

class DriverRequests extends Component {
    state = {
        requests : [],
        trackingCode : '',
        statuses : [],
        drivers : [],
        status: 0,
        date_from:moment().subtract(7,'days'),
        date_to: moment(),
        isLoaded:false,
        companyName : '',
        showModal : false,
        count : 0,
        searchButtonLabel : 'فیلتر'

    }
    onSearchTrackingCode = (event) => {
        this.setState({
            trackingCode:event.target.value
        })
        if(event.target.value.length > 2) {
            const request = {
                proccess_for : 'Expert',
                tracking_code : event.target.value,
                small_cargo : 0
            }
            API.requests(request)
                .then((response) => {
                    const requests = response.results.requests;
                    const count = response.results.count;
                    this.setState({requests,count})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
        if(event.target.value.length  < 1) {
            const request = {
                proccess_for : 'Expert',
                small_cargo : 0

            }
            API.requests(request)
                .then((response) => {
                    const requests = response.results.requests;
                    const count = response.results.count;
                    this.setState({requests , count})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
    }
    advancedSearch = (event) => {
        this.setState({searchButtonLabel : 'در حال جستجو'})
            const request = {
                proccess_for : 'Expert',
                company_name : this.state.companyName,
                status_id: this.state.status,
                date_from: this.state.date_from,
                date_to: this.state.date_to,
                small_cargo : 0
            }
            API.requests(request)
                .then((response) => {
                    const requests = response.results.requests;
                    const count = response.results.count;
                    this.setState({requests , count,showModal : false , searchButtonLabel : 'فیلتر  '})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });

    }
    onStateChange = (event) => {

        this.setState({status : event.target.value});
        const request = {
            proccess_for : 'Expert',
            status_id: event.target.value,
            company_name :  this.state.companyName,
            small_cargo : 0

        }
        API.requests(request)
            .then((response) => {
                const requests = response.results.requests;
                const count = response.results.count;
                this.setState({requests , count})

            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });

    }
    filterOpen = () => {
        document.getElementsByClassName('persian-date')[0].readOnly = true;
        document.getElementsByClassName('persian-date')[1].readOnly = true;
    }
    render() {
        return (
            <React.Fragment >
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast  />
                <Actionbar noBack={0} title=' لیست درخواست های راننده'/>

                <section className="container my-5 py-4 ">


                    <div className="row mb-2 rtl">
                        <div className="col-12 text-center super-small text-secondary pt-2">
                            تعداد کل :
                            &nbsp;
                            {this.state.count}
                            &nbsp;
                            درخواست
                        </div>

                    </div>
                    <div className="row px-2">
                        {
                            this.state.requests.map (request => {
                                return (
                                    <div className="col-12 rtl mb-2 request-row pb-2 bg-light "
                                         onClick={() => this.props.history.push(`/request/${request.id}`)}
                                         key={request.id}
                                    >
                                        <div className="row  mx-2 py-2">
                                            <div className="col-6 badge badge-info badge-pill bg-secondary float-right ">{request.company.title}
                                                &nbsp;
                                                :
                                                &nbsp;
                                                {request.tracking_code}</div>
                                            <div className="col-6 text-left super-small-2" style={{color:request.status.color}}>{request.status.title}</div>
                                           {/* <div className="col-12 mt-2 super-small">
                                                از:
                                                &nbsp;
                                                {request.loading_addresses[0].title}
                                                &nbsp;
                                                {request.loading_addresses[0].address.substring(0, 25)} ...
                                            </div>*/}

                                            <div className="col-12 mt-2 super-small">
                                                <FontAwesomeIcon icon={faDownload} />
                                                &nbsp;
                                                {request.unloading_addresses[0] && request.unloading_addresses[0].title}
                                                &nbsp;
                                                {request.unloading_addresses[0] && request.unloading_addresses[0].address.substring(0, 25)} ...
                                            </div>
                                            <div className="col-12 mt-3 super-small-2">
                                                <div className='float-left text-dark'>

                                                    {request.loading_date}
                                                    &nbsp;
                                                    <FontAwesomeIcon icon={faCalendarAlt} />

                                                </div>
                                                <div>
                                                    <FontAwesomeIcon icon={faTruck} className='text-secondary' />
                                                    &nbsp;
                                                    {request.car_type.parent}
                                                    &nbsp;
                                                    -
                                                    &nbsp;
                                                    {request.car_type.title}
                                                    &nbsp;&nbsp;
                                                    {request.driver.last_name ?

                                                        <strong>
                                                            (
                                                            {request.driver.last_name}
                                                            )
                                                        </strong>
                                                        : ''
                                                    }




                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                )} )
                        }
                    </div>
                </section>

                <Navbar  />
            </React.Fragment>
        );
    }
    componentDidMount() {
        const request = {

            driver_id: this.props.match.params.driver,
            status_id: this.props.match.params.status,
            proccess_for : 'ExpertDriver',

        }
        API.requests(request)
            .then((response) => {
                const requests = response.results.requests;
                const count = response.results.count;
                this.setState({requests , count , isLoaded : true})
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)
            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });




    }
}

export default DriverRequests;